import { Editor } from '@tinymce/tinymce-react';
import { MutableRefObject } from 'react';
import { Editor as TinyMCEEditor } from 'tinymce';

interface IShTinyMce {
    initialValue: string,
    editorRef: MutableRefObject<TinyMCEEditor | null>,
    isDisabled: boolean
};

export const ShTinyMce = ({ initialValue, editorRef, isDisabled }: IShTinyMce) => {

    return (
        <>
            <Editor
                apiKey='09s7kkxp2qzh008eswh1p9ueyfkvghp3y89pehhxdmqn2j7s'
                init={{
                    menubar: false,
                    plugins: [
                        'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                        'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                        'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                    ],
                    toolbar: 'undo redo | blocks | ' +
                        'bold italic forecolor | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | ' +
                        'removeformat | help'
                }}
                initialValue={initialValue}
                onInit={(evt, editor) => editorRef.current = editor}
                disabled={isDisabled}
            />
        </>
    );
}